import {ApplicationStoreType} from 'desktop/store';
import {MessageType} from 'types/cartType';

/**
 * Return coupon errors
 * @param {ApplicationStoreType} state - redux store
 * @returns {Array<string>} array of errors
 */
export const getErrorCouponsMessage = (state: ApplicationStoreType): Array<string> =>
    state.coupons && state.coupons.status === 'rejected'
        ? (state.coupons.error?.messages || [])
              .filter(({type}: MessageType) => type === 'error')
              .map(({message}: MessageType) => message)
        : [];

/**
 * Return coupon status
 * @param {ApplicationStoreType} state - redux store
 * @returns {string} coupon status
 */
export const getCouponsStatus = (state: ApplicationStoreType): string => {
    return state.coupons.status;
};
